import DonutChart, {
    getItemColor,
} from "../../charts/DonutChart/DonutChart";

import styles from "./CostBreakdownReport.module.css";


const CostBreakdownReport = ({
    data,
}) => {

    if (!data) {
        return null;
    }


    const items = data.items || [];


    return (

        <section
            className={styles.card}
        >

            <div
                className={styles.header}
            >

                <div>

                    <span
                        className={
                            styles.eyebrow
                        }
                    >
                        گزارش هزینه
                    </span>

                    <h2>
                        تفکیک هزینه‌ها
                    </h2>

                </div>

                <span
                    className={styles.badge}
                >
                    هزینه
                </span>

            </div>


            <DonutChart
                data={items}
            />


            <div
                className={styles.legend}
            >

                {
                    items.map(
                        (item, index) => (

                            <div
                                key={
                                    item.key ??
                                    index
                                }
                                className={
                                    styles.legendItem
                                }
                            >

                                <div
                                    className={
                                        styles.legendInfo
                                    }
                                >

                                    <span
                                        className={
                                            styles.dot
                                        }
                                        style={{
                                            backgroundColor:
                                                getItemColor(
                                                    item.key,
                                                    index
                                                ),
                                        }}
                                    />

                                    <span
                                        className={
                                            styles.name
                                        }
                                    >
                                        {item.label}
                                    </span>

                                </div>


                                <strong>
                                    {item.percentage}%
                                </strong>

                            </div>

                        )
                    )
                }

            </div>

        </section>

    );
};


export default CostBreakdownReport;
